// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"558f9a42","502":"9f9157dc","713":"128c4a19","767":"25ffa461","863":"25ffa461","901":"a4cfef80"}[chunkId] + ".chunk.css";
};